import { combineClassnames } from 'app/common/presentation'

import styles from './Progress.module.scss'

interface ProgressBarProps {
  percentage: number
  progressClassName?: string
}

const ProgressBar = ({ percentage, progressClassName }: ProgressBarProps) => (
  <div className={styles.progressBar}>
    <div style={{ width: `${percentage * 100}%` }}>
      <div className={combineClassnames(styles.progress, progressClassName)} />
    </div>
  </div>
)

export default ProgressBar
